

export class ChangeStatusModel {
  paymentId: string;
  bankReferenceId: string;
  merchantName: string;
  paymentMethod: string;
  bankName: string;
  receiptNumber: string;
  billNumber: string;
  transactionId: string;
  bankTransactionId: string;
  status: string;
  billerName: string;
}



export class EmiChangeStatusModel {
  transactionId: string;
  status: string;
}





// WEBPACK FOOTER //
// ./src/app/report/pg-emi-detailed-transaction-report/admin-emi-report.ts